










import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Button from '@/components/Button.vue';

@Component({
    components: {Button}
})
export default class extends Vue {
    @Prop() title: string | undefined;
    @Prop() type: string | undefined;


    ChangeTypeDay() {
        if (this.type !== '+') {
            this.$emit('update:type', '+');
        } else {
            this.$emit('update:type', '-');
        }


    }


}
